const SELOS_NAO_ENVIADOS = 'SELOS_NAO_ENVIADOS'
const CONTAGEM_DE_EXIBICAO_DOS_SELOS_NAO_ENVIADOS = 'CONTAGEM_DE_EXIBICAO_DOS_SELOS_NAO_ENVIADOS'
const CONTAGEM_DE_EXIBICAO_DE_TODOS_OS_SELOS = 'CONTAGEM_DE_EXIBICAO_DE_TODOS_OS_SELOS'

export default {
  namespaced: true,
  state: {
    selosNaoEnviados: false,
    contagemDeExibicaoDosSelosNaoEnviados: 0,
    contagemDeExibicaoDeTodosOsSelos: 0
  },
  getters: {
    getSelosNaoEnviados: (state) => state.selosNaoEnviados,
    getContagemDeExibicaoDosSelosNaoEnviados: (state) => state.contagemDeExibicaoDosSelosNaoEnviados,
    getContagemDeExibicaoDeTodosOsSelos: (state) => state.contagemDeExibicaoDeTodosOsSelos
  },
  mutations: {
    [SELOS_NAO_ENVIADOS] (state, status) {
      state.selosNaoEnviados = status
    },
    [CONTAGEM_DE_EXIBICAO_DOS_SELOS_NAO_ENVIADOS] (state, status) {
      if (state.contagemDeExibicaoDosSelosNaoEnviados < 5) {
        state.contagemDeExibicaoDosSelosNaoEnviados += status
      } else {
        state.contagemDeExibicaoDosSelosNaoEnviados = 0
      }
    },
    [CONTAGEM_DE_EXIBICAO_DE_TODOS_OS_SELOS] (state, status) {
      if (state.contagemDeExibicaoDeTodosOsSelos < 5) {
        state.contagemDeExibicaoDeTodosOsSelos += status
      } else {
        state.contagemDeExibicaoDeTodosOsSelos = 0
      }
    },
  },
  actions: {
    setSelosNaoEnviados ({ commit }, status) {
      commit(SELOS_NAO_ENVIADOS, status)
    },
    setContagemDeExibicaoDosSelosNaoEnviados ({ commit }, status) {
      commit(CONTAGEM_DE_EXIBICAO_DOS_SELOS_NAO_ENVIADOS, status)
    },
    setContagemDeExibicaoDeTodosOsSelos ({ commit }, status) {
      commit(CONTAGEM_DE_EXIBICAO_DE_TODOS_OS_SELOS, status)
    },
  }
}
